<template>
    <div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <v-container fluid>
            <v-card>
                <v-toolbar dense dark color="secondary" class="white--text">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                        Posting
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark icon :to="$store.state.analytics.return"
                        ><v-icon>mdi-arrow-left</v-icon></v-btn
                    >
                </v-toolbar>

                <div class="text-center" v-if="loadProgress">
                    <v-progress-linear
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-linear>
                </div>
                <v-container fluid class="divs">
                    <div>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th width="5%">
                                        Shfit Detail
                                    </th>
                                    <th width="10%">Shift Date</th>
                                    <th width="1%">Shift</th>
                                    <th width="15%">Driver</th>
                                    <th width="5%">Truck</th>
                                    <th width="5%">Replacement Unit</th>
                                    <th width="5%">Trailer</th>
                                    <th width="5%">Yard</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{ shift[0]['ShiftDetail'] }}
                                    </td>
                                    <td>
                                        {{ shift[0]['ShiftDate'] }}
                                    </td>
                                    <td>
                                        {{ shift[0]['Shift'] }}
                                    </td>
                                    <td>
                                        {{ shift[0]['Driver'] }}
                                    </td>
                                    <td>
                                        {{ shift[0]['Truck'] }}
                                    </td>
                                    <td>
                                        <span
                                            v-if="shift[0]['ReplacementUnit']"
                                        >
                                            {{
                                                shift[0]['ReplacementUnit']
                                            }}</span
                                        >
                                    </td>
                                    <td>
                                        {{ shift[0]['Trailer'] }}
                                    </td>

                                    <td>
                                        {{ shift[0]['Yard'] }}
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>

                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th width="15%">
                                        GPSShiftStart
                                    </th>
                                    <th width="15%">GPSShiftEnd</th>
                                    <th width="15%">Driver Type</th>
                                    <th width="5%">Rate</th>
                                    <th width="8%">Hours</th>
                                    <th width="10%">Driver Pay</th>
                                    <th width="10%">Calculate Pay</th>
                                    <th width="9%">Go to</th>
                                    <th width="9%">Go to</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td mask="####/##/##">
                                        {{ shift[0]['GPSShiftStart'] }}
                                    </td>
                                    <td>
                                        {{ shift[0]['GPSShiftEnd'] }}
                                    </td>
                                    <td>
                                        {{ shift[0]['DriverType'] }}
                                    </td>
                                    <td>
                                        {{ shift[0]['Rate'] }}
                                    </td>
                                    <td>
                                        {{ hours }}
                                    </td>
                                    <td>
                                        {{ shift[0]['DriverPay'] }}
                                    </td>
                                    <td>
                                        <v-btn
                                            small
                                            color="primary"
                                            @click="calculatePayDriver()"
                                            ><v-icon
                                                >mdi-calculator-variant</v-icon
                                            ></v-btn
                                        >
                                    </td>
                                    <td>
                                        <v-btn
                                            color="primary"
                                            small
                                            tile
                                            block
                                            @click="
                                                $store.state.posting.rdDialogTracking = true
                                            "
                                            ><v-icon>mdi-logout-variant</v-icon>
                                            GPS Tracking</v-btn
                                        >
                                    </td>
                                    <td>
                                        <v-btn
                                            color="primary"
                                            @click="openEditAssig"
                                            small
                                            block
                                            tile
                                            ><v-icon class="mr-1"
                                                >mdi-logout-variant</v-icon
                                            >
                                            Sft. Assignments</v-btn
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-row class="mt-1">
                            <v-col cols="7">
                                <table class="tbl-trs tbl-back">
                                    <tbody>
                                        <tr>
                                            <th
                                                colspan="1"
                                                width="30%"
                                                style="text-align:left;"
                                            >
                                                Actual Start Time
                                            </th>
                                            <th
                                                colspan="1"
                                                width="30%"
                                                style="text-align:left;"
                                            >
                                                Actual End Time
                                            </th>
                                            <th width="10%"></th>
                                            <th width="30%"></th>
                                        </tr>
                                        <tr>
                                            <td
                                                colspan="1"
                                                style="text-align:center;"
                                            >
                                                <v-text-field
                                                    @blur="calculatePayDriver"
                                                    id="ShiftStartTime"
                                                    hide-details
                                                    :value="
                                                        shift[0][
                                                            'ShiftStartTime'
                                                        ]
                                                    "
                                                    v-mask="
                                                        '####-##-## ##:##:##'
                                                    "
                                                    :rules="dateRules"
                                                    style="width:160px;margin: 0px;padding: 0px;"
                                                    type="tel"
                                                    dense
                                                ></v-text-field>
                                            </td>
                                            <td colspan="1">
                                                <v-text-field
                                                    @blur="calculatePayDriver"
                                                    id="ShiftEndTime"
                                                    hide-details
                                                    :value="
                                                        shift[0]['ShiftEndTime']
                                                    "
                                                    v-mask="
                                                        '####-##-## ##:##:##'
                                                    "
                                                    :rules="dateRules"
                                                    style="width:160px;margin: 0px;padding: 0px;"
                                                    dense
                                                    type="tel"
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-btn
                                                    x-small
                                                    style="float:left;"
                                                    color="secondary"
                                                    @click="changeDates()"
                                                    ><v-icon
                                                        >mdi-watch-export</v-icon
                                                    ></v-btn
                                                >
                                            </td>
                                            <td>
                                                <v-checkbox
                                                    style="margin-top: 0px;font-size: 10px; margin: 0px;padding: 0px; "
                                                    label="Daily Summary Check"
                                                    class="summary-color"
                                                    v-model="
                                                        shift[0][
                                                            'DailySummaryCheck'
                                                        ]
                                                    "
                                                    hide-details
                                                ></v-checkbox>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="tbl-trs tbl-back">
                                    <tbody>
                                        <tr>
                                            <th style="text-align:left;">
                                                OutofProvOdo Start
                                            </th>
                                            <th style="text-align:left;">
                                                Repl Odo Start
                                            </th>
                                            <th style="text-align:left;">
                                                Odo Start
                                            </th>
                                            <th>Paperwork Origin</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        shift[0][
                                                            'OutofProvOdoStart'
                                                        ]
                                                    "
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        shift[0][
                                                            'ReplUnitOdoStart'
                                                        ]
                                                    "
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        shift[0]['OdoStart']
                                                    "
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-combobox
                                                    v-model="
                                                        shift[0][
                                                            'PaperworkOrigin'
                                                        ]
                                                    "
                                                    hide-details
                                                    dense
                                                    :items="PaperworkOrigin"
                                                    :item-text="'Origin'"
                                                    :item-value="'ID'"
                                                    style="font-size: 13px; margin: 0px;padding: 0px;"
                                                    auto-select-first
                                                ></v-combobox>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th style="text-align:left;">
                                                OutofProvOdo End
                                            </th>
                                            <th style="text-align:left;">
                                                Reple Odo End
                                            </th>
                                            <th style="text-align:left;">
                                                Odo End
                                            </th>
                                            <th style="text-align:left;">
                                                Odo Total
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        shift[0][
                                                            'OutofProvOdoEnd'
                                                        ]
                                                    "
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    dense
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        shift[0][
                                                            'ReplUnitOdoEnd'
                                                        ]
                                                    "
                                                    dense
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="shift[0]['OdoEnd']"
                                                    :input="editableOdo()"
                                                    dense
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field
                                                    v-model="
                                                        shift[0]['OdoTotal']
                                                    "
                                                    style="width:100px;margin: 0px;padding: 0px;"
                                                    hide-details
                                                    dense
                                                    disabled
                                                ></v-text-field>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-col>
                            <v-col>
                                <v-textarea
                                    v-model="shift[0]['PayrollComments']"
                                    class="mx-2"
                                    label="Payroll Comments"
                                    rows="2"
                                    hide-details
                                    prepend-icon="mdi-comment"
                                ></v-textarea>

                                <v-row justify="end" class="mt-4">
                                    <v-btn
                                        class="mx-3"
                                        color="secondary"
                                        @click="loadOrders"
                                        >Refresh Orders</v-btn
                                    >
                                    <v-btn
                                        class="mx-3"
                                        color="secondary"
                                        @click="saveShift()"
                                        >Save</v-btn
                                    >
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-col>
                            <v-data-table
                                dense
                                :headers="OrdersHeader"
                                :items="orders"
                                class="elevation-1"
                                sort-by="LoadNum"
                                hide-default-footer
                                disable-sort
                            >
                                <template v-slot:item.action="{ item }">
                                    <v-icon
                                        persistent
                                        class="mx-3"
                                        color="primary"
                                        dark
                                        small
                                        @click="openModalOrder(item)"
                                        >mdi-open-in-new</v-icon
                                    >
                                </template>

                                <template v-slot:item.demurrage="{ item }">
                                    <v-icon
                                        persistent
                                        class="mx-3"
                                        color="primary"
                                        dark
                                        small
                                        @click="openModalDemurrage(item)"
                                        >mdi-clock</v-icon
                                    >
                                </template>
                                <template v-slot:item.duplicate="{ item }">
                                    <v-btn
                                        color="red"
                                        icon
                                        @click="confirmDeleteOrder(item)"
                                        v-if="item.SplitTypeID == 9"
                                    >
                                        <v-icon>mdi-delete-circle</v-icon>
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        icon
                                        @click="onDuplicate(item)"
                                        v-else
                                    >
                                        <v-icon>mdi-content-duplicate</v-icon>
                                    </v-btn>
                                </template>
                                <template v-slot:item.OrderStatus="{ item }">
                                    <td
                                        style="text-align:center;background-color:#edd480;"
                                        v-if="item.OrderStatus == 'PRELOAD'"
                                    >
                                        {{ item.OrderStatus }}
                                    </td>
                                    <td
                                        style="text-align:center;background-color:#cef5a9;"
                                        v-else-if="
                                            item.OrderStatus == 'PRLDISPAT'
                                        "
                                    >
                                        {{ item.OrderStatus }}
                                    </td>
                                    <td style="text-align:center;" v-else>
                                        {{ item.OrderStatus }}
                                    </td>
                                </template>

                                <template v-slot:item.LoadNum="{ item }">
                                    <v-text-field
                                        dense
                                        hide-details
                                        v-model="item.LoadNum"
                                        @change="onLoadOrderChange(item)"
                                    ></v-text-field>
                                </template>
                                <template v-slot:item.LoadNumOrd="{ item }">
                                    <v-text-field
                                        dense
                                        hide-details
                                        v-model="item.LoadNumOrd"
                                        @change="onLoadOrderChange(item)"
                                    ></v-text-field>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col>
                            <v-data-table
                                :headers="dmrgHeaders"
                                :items="dmrg"
                                class="elevation-1"
                                hide-default-footer
                                disable-sort
                                dense
                            >
                                <template v-slot:item.edit="{ item }">
                                    <v-icon
                                        persistent
                                        class="mx-3"
                                        color="primary"
                                        dark
                                        @click="editDmr(item)"
                                        >mdi-clipboard-edit-outline</v-icon
                                    >
                                </template>
                                <template v-slot:item.delete="{ item }">
                                    <v-icon
                                        persistent
                                        class="mx-3"
                                        color="red"
                                        dark
                                        @click="dltTrnsConfirm(item)"
                                        >mdi-delete</v-icon
                                    >
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-row>
                            <v-col>
                                <v-textarea
                                    v-model="shift[0]['AdmComments']"
                                    class="mx-2"
                                    label="Admin Comments"
                                    rows="3"
                                    hide-details
                                    prepend-icon="mdi-comment"
                                    disabled
                                ></v-textarea>
                            </v-col>
                            <v-col>
                                <v-textarea
                                    v-model="shift[0]['ShiftAssmtComments']"
                                    class="mx-2"
                                    label="Shift Comments"
                                    rows="3"
                                    hide-details
                                    prepend-icon="mdi-comment"
                                    disabled
                                ></v-textarea>
                            </v-col>
                            <v-col>
                                <v-textarea
                                    v-model="shift[0]['GPSComments']"
                                    class="mx-2"
                                    label="GPS Comments"
                                    rows="3"
                                    hide-details
                                    prepend-icon="mdi-comment"
                                    disabled
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </v-card>
            <div class="text-center">
                <v-snackbar v-model="snackbar">
                    {{ text }}
                    <v-btn text color="red" @click="snackbar = false"
                        >Close</v-btn
                    >
                </v-snackbar>
            </div>

            <v-container style="background: #fff" grid-list-xs>
                <edtAssignment
                    v-if="$store.state.assignment.dialog"
                    :data="shift"
                ></edtAssignment>
            </v-container>

            <rdTracking
                v-if="$store.state.posting.rdDialogTracking"
                :params="shift"
            ></rdTracking>

            <AddDemurrage
                v-if="$store.state.demurrage.dialog"
                :dmData="dmData"
            />
            <edtDemurrage
                v-if="$store.state.demurrage.edit"
                :dmData="editDemurrage"
            ></edtDemurrage>

            <v-dialog
                v-model="$store.state.posting.dialog"
                transition="dialog-bottom-transition"
                overlay-color="accent"
                width="1500"
            >
                <OrderData v-if="$store.state.posting.dialog" />
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import OrderData from './../Modals/Administration/OrderEdit.vue';
import AddDemurrage from './../Modals/Administration/Demurrage/AddDemurrage.vue';
import edtDemurrage from './../Modals/Administration/Demurrage/EditDemurrage.vue';
import edtAssignment from '../Modals/Dispatch/Shift Assignments/EditAssignmentsPosting.vue';
import rdTracking from './../Modals/Dispatch/Tracking/ReadGPSTracking.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';

export default {
    name: 'Posting',
    components: {
        OrderData,
        edtAssignment,
        rdTracking,
        AddDemurrage,
        edtDemurrage,
        ConfirmDialogue
    },
    directives: {
        mask
    },
    data: function() {
        return {
            OrdersHeader: [
                {
                    text: 'Action',
                    value: 'action',
                    width: '1%'
                },
                {
                    text: 'Dmr',
                    value: 'demurrage',
                    width: '1%'
                },
                { text: 'L1', value: 'LoadNum', width: '3%' },
                { text: 'L2', value: 'LoadNumOrd', width: '3%' },
                { text: 'Order #', value: 'OrderID', width: '1%' },
                { text: 'Status', value: 'OrderStatus', width: '1%' },

                { text: 'Bol #', value: 'BOL', width: '5%' },

                { text: 'Customer', value: 'Customer', width: '25%' },
                { text: 'Terminal', value: 'Terminal', width: '20%' },
                { text: 'Station', value: 'Station', width: '20%' }
                // { text: 'Dup', value: 'duplicate', width: '3%' }
            ],
            editDemurrage: [],
            parms: [],
            dmrgHeaders: [
                { text: 'Edit', value: 'edit', width: '5%' },
                { text: 'Delete', value: 'delete', width: '5%' },
                {
                    text: 'Order',
                    value: 'OrderNumber',
                    width: '10%'
                },
                { text: 'Dem Type', value: 'TransactionName', width: '20%' },
                { text: 'Hours', value: 'Quantity', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '5%' },
                { text: 'Amount', value: 'Amount', width: '10%' },
                { text: 'Description', value: 'Description', width: '50%' }
            ],
            status: '',
            snackbar: false,
            dmrg: [],
            orders: [],
            orderInfo: [],
            searchShift: null,
            shift: [],
            PaperworkOrigin: [],
            loadData: false,
            dialog: false,
            text: '',
            loadProgress: false,
            hours: '',
            hoursCal: '',
            dmData: [],
            dltDmr: [],
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[11] + v[12]) <= 24 &&
                        parseInt(v[11] + v[12]) >= 0) ||
                    'Hour Incorrect',
                v =>
                    (parseInt(v[14] + v[15]) <= 59 &&
                        parseInt(v[14] + v[15]) >= 0) ||
                    'Minutes Incorrect'
            ]
        };
    },
    watch: {
        '$store.state.posting.watch': function() {
            if (this.$store.state.posting.watch == true) {
                this.loadShift();
            } else {
                console.log('test');
            }
        }
    },
    mounted() {
        this.searchShift = this.$store.state.analytics.subItem.ShiftDetail;
        this.loadShift();
    },
    methods: {
        editDmr: function(itm) {
            this.editDemurrage = itm;
            this.$store.state.demurrage.edit = true;
            this.$store.state.posting.watch = false;
        },
        deleteTrnsaction: function(itm) {
            var str = this.$store;
            axios
                .delete('transaction/' + itm)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete transaction successful.'
                    });
                    this.loadExtraPay();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        async dltTrnsConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this transaction',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteTrnsaction(itm.TranId);
            }
        },
        loadShift: async function() {
            var str = this.$store;
            str.state.isLoading = true;
            await axios
                .get('shift-detail/resource/' + this.searchShift)
                .then(async response => {
                    this.shift = response.data;
                    this.shift[0].ShiftDetail = this.searchShift;
                    this.loadData = true;
                    await this.loadOrders();
                    await this.loadPaperworkOrigin();
                    await this.loadExtraPay();
                    this.calculateHours();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    if (error.response.status === 404) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Shift not found'
                        });
                    }
                });
            this.loadProgress = false;
        },
        loadOrders: function() {
            this.$store.state.isLoading = true;
            axios
                .get('order/shift/' + this.searchShift)
                .then(response => {
                    this.orders = response.data;
                    console.log(this.orders);
                })
                .catch(function(error) {
                    console.log(error);
                });

            this.$store.state.isLoading = false;
        },
        loadPaperworkOrigin: function() {
            axios
                .get('paperwork-origin')
                .then(response => {
                    this.PaperworkOrigin = response.data;
                    console.log(this.PaperworkOrigin);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadExtraPay: function() {
            axios
                .get('transaction/extra-payroll/' + this.searchShift)
                .then(response => {
                    this.dmrg = response.data.data;
                    console.log(this.dmrg);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        openModalOrder: function(item) {
            if (item.OrderStatus == 'PRELOAD' && item.PreloadOrderID != null) {
                this.$store.state.orderInfo.orderId = item.PreloadOrderID;
            } else {
                this.$store.state.orderInfo.orderId = item.OrderID;
            }
            this.$store.state.posting.dialog = true;
        },
        openModalDemurrage: function(item) {
            this.dmData = {
                shift: this.searchShift,
                orderID: item.OrderID
            };
            console.log(this.dmData);

            this.$store.state.posting.watch = false;
            this.$store.state.demurrage.dialog = true;
        },
        editableOdo: function() {
            this.shift[0]['OdoTotal'] =
                this.shift[0]['OdoEnd'] - this.shift[0]['OdoStart'];
        },
        saveShift: function() {
            var str = this.$store;
            var paperwork = null;
            if (this.shift[0]['PaperworkOrigin'] != null) {
                paperwork = this.shift[0]['PaperworkOrigin'].ID;
            }
            var pay = this.shift[0]['DriverPay'];
            pay = isNaN(pay) ? 0 : pay;
            var params = {
                ShiftStartTime: this.getMsk('ShiftStartTime'),
                ShiftEndTime: this.getMsk('ShiftEndTime'),
                OdoStart: this.shift[0]['OdoStart'],
                OdoEnd: this.shift[0]['OdoEnd'],
                OdoTotal: this.shift[0]['OdoTotal'],
                ReplUnitOdoStart: this.shift[0]['ReplUnitOdoStart'],
                ReplUnitOdoEnd: this.shift[0]['ReplUnitOdoEnd'],
                OutofProvOdoStart: this.shift[0]['OutofProvOdoStart'],
                OutofProvOdoEnd: this.shift[0]['OutofProvOdoEnd'],
                DailySummaryCheck: this.shift[0]['DailySummaryCheck'],
                PaperworkOrigin: paperwork,
                AdmComments: this.shift[0]['AdmComments'],
                DriverPay: pay,
                PayrollComments: this.shift[0]['PayrollComments']
            };
            console.log(params);
            axios
                .put('shift-detail/' + this.searchShift, params)
                .then(response => {
                    console.log(response);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Saved'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        calculateHours: function() {
            if (
                this.shift[0]['ShiftStartTime'] == '' ||
                this.shift[0]['ShiftEndTime'] == ''
            ) {
                console.log('null');
            } else {
                var hr = 0;
                var date_start = new Date(this.getMsk('ShiftStartTime'));
                var date_end = new Date(this.getMsk('ShiftEndTime'));
                var diff = date_end.getTime() - date_start.getTime();
                console.log(diff);
                hr = diff / 3600000;
                this.hoursCal = hr;
                this.hours = hr.toFixed(2);

                // var diff = (this.shift[0]['ShiftEndTime'] - this.shift[0]['ShiftStartTime']) * 24;
                // console.log(diff);

                // this.hoursCal = diff;
                // this.hours = diff.toFixed(2);
            }
        },
        onLoadOrderChange: function(order) {
            console.log(order);
            var str = this.$store;
            var params = {
                LoadNum: order.LoadNum,
                LoadNumOrd: order.LoadNumOrd
            };
            axios
                .put('order/' + order.OrderID, params)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log('Success!');
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Load order changed'
                    });
                })
                .catch(function(error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        calculatePayDriver: function() {
            this.calculateHours();
            if (this.hours == '') {
                console.log('Null');
            } else {
                var Dpay = 0;
                console.log(this.hours + ' Hrs');

                Dpay = this.hoursCal * this.shift[0]['Rate'];

                this.shift[0]['DriverPay'] = Dpay.toFixed(2);
            }
        },
        changeDates: function() {
            this.shift[0]['ShiftEndTime'] = this.setMsk(
                'ShiftEndTime',
                this.shift[0]['GPSShiftEnd']
            );
            this.shift[0]['ShiftStartTime'] = this.setMsk(
                'ShiftStartTime',
                this.shift[0]['GPSShiftStart']
            );
        },
        openEditAssig: function() {
            this.$store.state.assignment.dialog = true;
            this.$store.state.posting.watch = false;
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        setMsk: function(id, vl) {
            return (document.getElementById(id).value = vl);
        },
        copyOrder: function(itm) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('order/duplicate/' + itm.OrderID)
                .then(response => {
                    console.log(response.data);
                    this.loadOrders();
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successful Duplicate Order '
                    });
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        async onSaveShift() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Save shift',
                message: 'Do you want to save the changes?',
                okButton: 'Save'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.saveShift();
            }
        },
        async onDuplicate(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Save shift',
                message: 'Do you want to duplicate this order?',
                okButton: 'Save'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.copyOrder(itm);
            }
        },
        async confirmDeleteOrder(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this order',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteOrder(itm);
            }
        },
        deleteOrder: function(itm) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('order/duplicate/delete/' + itm.OrderID)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order removed successfully.'
                    });
                    this.loadOrders();
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    if (error.response.status == 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Failed to delete order, already dispatched.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        }
    }
};
</script>
<style>
.tbl-back td input {
    background: #fffae8;
}
.summary-color .v-input__slot label {
    color: #000;
}
.theme--light .v-label {
    color: #000;
}
div.chps {
    float: left;
}
.chps > span {
    width: 100%;
}
div.divs {
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
}
</style>
